// @ts-nocheck
import { useState, useLayoutEffect } from 'react';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function Footer() {
  const [viewFlag, setViewFlag] = useState(false);

  useLayoutEffect(() => {
    const url = window.location.href;
    const lastChar = url.slice(-1);

    if (lastChar !== '/') {
      setViewFlag(true);
    }
  }, []);

  function scrollToTop() {
    const root = document.scrollingElement || document.documentElement;
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion && 'scrollBehavior' in document.documentElement.style) {
      root.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const start = root.scrollTop;
      const duration = 500;
      const startTime = performance.now();
      const easeOutQuad = (t: number) => t * (2 - t);

      const tick = (now: number) => {
        const t = Math.min(1, (now - startTime) / duration);
        root.scrollTop = start * (1 - easeOutQuad(t));
        if (t < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    }
  }

  function Search() {
    const baseUrl = 'https://secure.okbiz.jp/zenken/category/search?keyword=';
    const target = document.getElementById('footer-search-form')?.value || '';
    window.open(baseUrl + target);
  }

  function SearchClick(e) {
    if (e.keyCode === 13) {
      const baseUrl = 'https://secure.okbiz.jp/zenken/category/search?keyword=';
      const target = document.getElementById('footer-search-form')?.value || '';
      window.open(baseUrl + target);
    }
  }

  return (
    <footer>
      <div className="footer">
        <p className="m-0 copyright" lang="en">
          (C)2026 Zenken Corporation
        </p>

        {viewFlag ? (
          <>
            <button
              className="button page_top_btn"
              onClick={scrollToTop}
            >
            </button>
          </>
        ) : null}

<div className='footer-z-boss'>
              <div className="z-boss-container">
                <div className="z-boss-header">
                  <div className="z-boss-icon">
                    <img src="/z_boss.png" alt="" />
                  </div>
                  <p className="z-boss-text">
                    迷ったらZ-BOSS！
                  </p>
                </div>

                <div className="header-search-box z-boss-search">
                  <input
                    type="text"
                    className="form-control"
                    id="footer-search-form"
                    placeholder="Z-BOSSで検索"
                    onKeyUp={SearchClick}
                  />
                  <OverlayTrigger overlay={<Tooltip id="footer-search">検索する</Tooltip>}>
                    <Button
                      className="header-search-botton"
                      type="button"
                      id="footer-search-button"
                      onClick={Search}
                    >
                      <img
                        src="/search_icon_blue.svg"
                        alt="検索する"
                        className="notice-bell"
                      />
                    </Button>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
      </div>
    </footer>
  );
}

export default Footer;